import { render } from "./Class.vue?vue&type=template&id=2a4865d2&scoped=true"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"

import "./Class.vue?vue&type=style&index=0&id=2a4865d2&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4865d2"]])

export default __exports__